export default function Subheader({ children, className }) {
  return <div className={`${className} text-xl font-semibold`}>{children}</div>;
}
